<template>
  <app-layout>
    <div v-if="currentUser">
      <div class="max-w-screen-xl mx-auto p-5">
        <div class="block border-2 rounded border-gray-100">
          <h2
            class="p-2 pl-4 border-b-2 border-gray-100 w-full bg-gray-50 block uppercase tracking-wide text-gray-700 text-xs font-bold"
          >
            Account
          </h2>

          <div class="p-2">
            Signed in as
            <span class="font-bold">{{
              currentUser.email
            }}</span
            >.

            <el-button
              @click="signOut()"
              class="ml-2"
              size="small"
              >Sign out</el-button
            >
          </div>
        </div>

        <div
          class="mt-4 block border-2 rounded border-gray-100"
        >
          <h2
            class="p-2 pl-4 border-b-2 border-gray-100 w-full bg-gray-50 block uppercase tracking-wide text-gray-700 text-xs font-bold"
          >
            Plan
          </h2>

          <div class="p-2" v-if="!premium">
            <el-tag type="info" class="mr-2"
              >Preview</el-tag
            >
            <router-link to="/pricing">
              <el-button size="small" type="primary"
                >Upgrade</el-button
              >
            </router-link>
          </div>

          <div class="p-2" v-if="premium">
            <div>
              <el-tag type="warning" class="mr-2"
                >Developer</el-tag
              >

              <span v-if="expiresAt" class="ml-2">{{
                expiresAtFormatted
              }}</span>
            </div>
          </div>

          <div v-if="credits" class="p-2">
            Credits:
            <span class="b">{{ credits }}</span>
          </div>
        </div>

        <div
          class="mt-4 block border-2 rounded border-red-100"
        >
          <h2
            class="p-2 pl-4 border-b-2 border-red-100 w-full bg-red-50 block uppercase tracking-wide text-red-700 text-xs font-bold"
          >
            Danger Zone
          </h2>

          <div class="p-2">
            <el-button
              @click="confirmDeleteAccount()"
              size="small"
              type="danger"
              plain
              >Delete Account</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </app-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';

export default {
  name: 'app-auth-account',

  async created() {
    const authenticated = await this.authenticatedAsync();

    if (!authenticated) {
      this.$router.push('/');
      return;
    }
  },

  computed: {
    ...mapGetters({
      authenticatedAsync: 'auth/authenticatedAsync',
      currentUser: 'auth/currentUser',
      credits: 'credits/credits',
      premium: 'credits/premium',
      expiresAt: 'credits/expiresAt',
    }),

    expiresAtFormatted() {
      if (!this.expiresAt) {
        return null;
      }

      return `Ends at ${moment(
        this.expiresAt?.toDate(),
      ).format('LL')}.`;
    },
  },

  methods: {
    ...mapActions({
      deleteAccount: 'auth/deleteAccount',
      signOut: 'auth/signOut',
    }),

    async confirmDeleteAccount() {
      try {
        await this.$confirm(
          `This is IRREVERSIBLE and will delete ALL YOUR DATA. Are you sure?`,
          'Confirm',
          {
            dangerouslyUseHTMLString: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            type: 'error',
          },
        );
      } catch (error) {
        return;
      }

      await this.deleteAccount();
    },
  },
};
</script>

<style></style>
